import React from 'react';
import ReactDOM from 'react-dom';

import FormLogin from '../auth/components/forms/FormLogin.jsx';
import FormThemeReportsLogin from '../auth/components/forms/FormThemeReportsLogin.jsx';

const root = document.getElementById('form-login');
const rootThemeReports = document.getElementById('form-theme-reports-login');

if (root) {
  ReactDOM.render(
    <FormLogin
      router={false}
    />,
    root,
  );
}
if (rootThemeReports) {
  ReactDOM.render(
    <FormThemeReportsLogin
      router={false}
    />,
    rootThemeReports,
  );
}
